var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cargo-ag-grid-assembly-editor" },
    [
      _vm.params.field === _vm.QUANTITY_NOT_ASSEMBLY_LABEL.code
        ? _c("el-input", {
            attrs: { type: "number", precision: 0, min: 0 },
            on: { input: _vm.handleChange },
            model: {
              value: _vm.quantityNotAssembly,
              callback: function($$v) {
                _vm.quantityNotAssembly = _vm._n($$v)
              },
              expression: "quantityNotAssembly"
            }
          })
        : _vm._e(),
      _vm.params.field === _vm.QUANTITY_NOT_ASSEMBLY_LABEL.code
        ? _c("span", [
            _vm._v(
              _vm._s(
                _vm.ColumnUtils.number3ColumnLabelFunc2(
                  _vm.params.data.quantityAssembly
                )
              ) +
                " / " +
                _vm._s(
                  _vm.ColumnUtils.number3ColumnLabelFunc2(
                    _vm.params.data.quantity
                  )
                )
            )
          ])
        : _vm._e(),
      _vm.params.field === _vm.WEIGHT_NOT_ASSEMBLY_LABEL.code
        ? _c("el-input", {
            attrs: { type: "number", precision: 0, min: 0 },
            on: { input: _vm.handleChange },
            model: {
              value: _vm.weightNotAssembly,
              callback: function($$v) {
                _vm.weightNotAssembly = _vm._n($$v)
              },
              expression: "weightNotAssembly"
            }
          })
        : _vm._e(),
      _vm.params.field === _vm.WEIGHT_NOT_ASSEMBLY_LABEL.code
        ? _c("span", [
            _vm._v(
              _vm._s(
                _vm.ColumnUtils.number3ColumnLabelFunc2(
                  _vm.params.data.weightAssembly
                )
              ) +
                " / " +
                _vm._s(
                  _vm.ColumnUtils.number3ColumnLabelFunc2(
                    _vm.params.data.weight
                  )
                )
            )
          ])
        : _vm._e(),
      _vm.params.field === _vm.CUBAGE_NOT_ASSEMBLY_LABEL.code
        ? _c("el-input", {
            attrs: { type: "number", precision: 0, min: 0 },
            on: { input: _vm.handleChange },
            model: {
              value: _vm.cubageNotAssembly,
              callback: function($$v) {
                _vm.cubageNotAssembly = _vm._n($$v)
              },
              expression: "cubageNotAssembly"
            }
          })
        : _vm._e(),
      _vm.params.field === _vm.CUBAGE_NOT_ASSEMBLY_LABEL.code
        ? _c("span", [
            _vm._v(
              _vm._s(
                _vm.ColumnUtils.number3ColumnLabelFunc2(
                  _vm.params.data.cubageAssembly
                )
              ) +
                " / " +
                _vm._s(
                  _vm.ColumnUtils.number3ColumnLabelFunc2(
                    _vm.params.data.cubage
                  )
                )
            )
          ])
        : _vm._e(),
      _vm.params.field === _vm.CHARGE_NOT_WEIGHT_ASSEMBLY_LABEL.code
        ? _c("el-input", {
            attrs: { type: "number", precision: 0, min: 0 },
            on: { input: _vm.handleChange },
            model: {
              value: _vm.chargeWeightNotAssembly,
              callback: function($$v) {
                _vm.chargeWeightNotAssembly = _vm._n($$v)
              },
              expression: "chargeWeightNotAssembly"
            }
          })
        : _vm._e(),
      _vm.params.field === _vm.CHARGE_NOT_WEIGHT_ASSEMBLY_LABEL.code
        ? _c("span", [
            _vm._v(
              _vm._s(
                _vm.ColumnUtils.number3ColumnLabelFunc2(
                  _vm.params.data.chargeWeightAssembly
                )
              ) +
                " / " +
                _vm._s(
                  _vm.ColumnUtils.number3ColumnLabelFunc2(
                    _vm.params.data.chargeWeight
                  )
                )
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }